export default {
  checkout: {
    // Fields

    /*********************************************************************************************
     * User configurable messages
     * TODO: Populate from API
     */
    privacyButton: ' política de privacidad',
    privacyPolicyRequiredMessage: 'Debe aceptar la política de privacidad para continuar.',
    shareRating: 'Puntuó {0}',
    shareComment: "Dijo '{n}'",
    shareStaffApplaud: 'Aplaudió {n}',
    shareSocialSubject: '¡Recomiendo este lugar!',
    shareSocialMsg: 'Acabo de visitar {n}. Esta es mi opinión: #feeditback',
    share: {
      title: 'Gracias por usar 125 Data & Insights',
      link: {
        facebook: 'Compartir en Facebook',
        twitter: 'Compartir en X',
        email: 'Compartir via correo electrónico'
      },
      tip: {
        label: 'Deja una propina'
      }
    },
    recommend: {
      skip: 'Saltar',
      suggestions: {
        title: 'Comentarios sugeridos generados por IA',
        description: 'Por favor comparte tu experiencia',
        copy: 'Copiar al portapapeles',
        copied: 'Copiado',
        copiedToClipboard: 'Copiado al portapapeles',
        error: 'No hay suficiente información para generar una respuesta informada',
        generate: 'Generar texto AI'
      }
    },
    email: 'Correo electrónico',
    emailAlt: 'Comparta esto por correo electrónico',
    //dynamic use
    facebookAlt: 'Comparta esto por Facebook',
    //dynamic use
    googleAlt: 'Crea un comentario en Google',
    //dynamic use
    thankYouHeader: 'Gracias',
    thankYouPermission: '¡Gracias!',
    thankYouVoucher: '¡Gracias por vuestro tiempo! Esperamos que disfrute del cupón.',
    voucherScratchText: "Scratch here to\n    claim your voucher!",
    // TODO: Doesn't require a translation as there are no vouchers used by international clients
    weAreSorryHeader: 'Lo lamentamos',
    weAreSorryText: 'Texto para expresar que lo lamentamos',
    uploadFileSizeError: 'Su carga debe de ser menor a {n}',
    uploadError: 'Error desconocido',
    uploadDelete: 'Eliminar fotografía',
    recaptchaCheckbox: 'No soy un robot'
  }
};